<div class="container">
  <app-card-view-automats [automatList]="automats"
                          [automatListFiltered]="automats"
                          [automatListStats]="automatStats"></app-card-view-automats>
</div>
